import styled from "styled-components";
import {LobbyHeaderButtonDefaultBox} from "./lobby-header-button.default.box";

export const LobbyHeaderButtonCasino777Box = styled(LobbyHeaderButtonDefaultBox)`
    border: 2px solid ${props => props.theme.colors.moneyColor}80;
    border-radius: 5px;
    color: ${props => props.theme.colors.moneyColor};
`;
